module.exports = __webpack_public_path__ + "img/frame_interate_titlebg.c7cda84a.png";